import dayjs from "dayjs"
import { pick } from "lodash"
import { serialize } from "object-to-formdata"
import { toaster } from "components/common/Toast"

// Builds the Ant Design form initial values from a guide client record.
export const buildClientInitialValues = (client) => ({
  ...client.user,
  avatar: client.user.avatar || null,
  phone_number: {
    fullNumber: client.user.phone_number || "",
    countryCode: client.user.country_code || ""
  },
  country_code: client.user.country_code || "",
  state: client.user.state || "",
  country: client.user.country || "",
  street_address: client.user.address_line_1 || "",
  zip_code: client.user.zip_code || "",
  birthday: client.user.birthday ? dayjs(client.user.birthday) : null,
  client_groups: client.client_groups || []
})

// Builds user_attributes for the guide client payload.
export const buildUserAttributes = (values) => {
  const user_attributes = pick(values, [
    "id",
    "nickname",
    "avatar",
    "gender",
    "first_name",
    "last_name",
    "email",
    "phone_number",
    "country_code",
    "birthday",
    "address_line_1",
    "address_line_2",
    "city",
    "state",
    "country",
    "zip_code"
  ])
  if (user_attributes.avatar && !(user_attributes.avatar instanceof File)) {
    delete user_attributes.avatar
  }
  if (!values.email) {
    user_attributes.no_email = true
  }
  return user_attributes
}

export const buildGroupClientsAttributes = (client_groups) =>
  client_groups?.map((group) => ({
    group_id: group?.group_id || group?.id
  })) || []

export const buildNotesAttributes = (notes) => (notes ? notes.map((note) => ({ content: note.content })) : [])

// Serializes validated form values into the multipart payload the guide client endpoints expect.
export const buildGuideClientFormData = (formValues, client, clientId) => {
  if (formValues?.street_address) formValues.address_line_1 = formValues.street_address
  if (clientId) formValues.id = client?.user?.id

  const values = {
    ...formValues,
    phone_number: formValues.phone_number?.fullNumber,
    country_code: formValues.phone_number?.countryCode,
    birthday: formValues.birthday ? formValues.birthday.format("YYYY-MM-DD") : null
  }

  const guide_client = {
    cash_payment: values.cash_payment,
    group_clients_attributes: buildGroupClientsAttributes(values.client_groups),
    notes_attributes: buildNotesAttributes(values.notes),
    user_attributes: buildUserAttributes(values),
    is_manual_address: formValues?.manualAddress || false
  }

  return serialize({ guide_client }, { indices: true })
}

// Maps API errors back onto the form fields / surfaces a toast.
export const handleClientFormErrors = (err, clientId, form, t) => {
  if (clientId) {
    toaster.error(t("client.client_failed", { name: form?.getFieldValue("first_name") }))
  }
  if (err?.data?.errors?.email) {
    form.setFields([{ name: "email", errors: [err.data.errors.email] }])
  }
  if (err?.data?.errors?.avatar) {
    form.setFields([{ name: "avatar", errors: [err.data.errors.avatar] }])
  }
}
